module.exports = __webpack_public_path__ + "img/2025-4.71181b3d.jpg";